document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.is-anchor').forEach((anchor) => {
		anchor.addEventListener('click', function (event) {
			if (
				this.hasAttribute('href') &&
				this.getAttribute('href').includes('#')
			) {
				event.preventDefault();

				const targetId = this.getAttribute('href').substring(1);
				const targetElement = document.getElementById(targetId);

				targetElement.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});

				setTimeout(() => {
					const collapseTrigger = targetElement.previousElementSibling;
					if (
						collapseTrigger &&
						!collapseTrigger.classList.contains('is-active')
					) {
						collapseTrigger.click();
						collapseTrigger.classList.add('is-active');
						targetElement.classList.add('is-active');
						targetElement.setAttribute('aria-expanded', 'true');
					}
				}, 500);
			}
		});
	});

	document.querySelectorAll('.is-print').forEach((print) => {
		print.addEventListener('click', function (event) {
			event.preventDefault();
			window.print();
		});
	});
});
